import type { CustomField } from "@repo/app-types/entities/customField";
import {
  TagType,
  getTagsInvalidatedByUpdate,
  getTagsProvidedByEntity,
} from "../helpers/tags.js";
import { api } from "../redux.js";

/** Generates a composite cache tag ID, since either the project ID or custom field name alone is not unique. */
function getProjectCustomFieldId(
  projectId: string,
  customFieldName: string,
): string {
  return `${projectId}/${customFieldName}`;
}

const projectCustomFieldApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Project custom field endpoints.
    // TODO: Dedupe.
    projectCustomField: builder.query<
      CustomField | null,
      { projectId: string; customFieldName: string },
      { data: { custom_field: CustomField | null } }
    >({
      query: ({ projectId, customFieldName }) =>
        `/projects/${encodeURIComponent(projectId)}/custom_fields/${encodeURIComponent(customFieldName)}`,
      transformResponse: (response) => response.data.custom_field,
      providesTags: (result, error, { projectId, customFieldName }) =>
        getTagsProvidedByEntity(
          TagType.CustomField,
          getProjectCustomFieldId(projectId, customFieldName),
        ),
    }),
    updateProjectCustomField: builder.mutation<
      CustomField | null,
      {
        projectId: string;
        customFieldName: string;
        data: CustomField["data"];
      },
      { data: { custom_field: CustomField | null } }
    >({
      query: (values) => ({
        method: "PUT",
        url: `/projects/${encodeURIComponent(values.projectId)}/custom_fields/${encodeURIComponent(values.customFieldName)}`,
        body: values.data,
      }),
      transformResponse: (response) => response.data.custom_field,
      invalidatesTags: (result, error, { projectId, customFieldName }) =>
        getTagsInvalidatedByUpdate(
          TagType.CustomField,
          getProjectCustomFieldId(projectId, customFieldName),
        ),
    }),
  }),
});

export const {
  useLazyProjectCustomFieldQuery,
  useUpdateProjectCustomFieldMutation,
} = projectCustomFieldApi;
